import { render, staticRenderFns } from "./OrdersCrmStats.vue?vue&type=template&id=d0617fa8&scoped=true&lang=pug"
import script from "./OrdersCrmStats.vue?vue&type=script&lang=js"
export * from "./OrdersCrmStats.vue?vue&type=script&lang=js"
import style0 from "./OrdersCrmStats.vue?vue&type=style&index=0&id=d0617fa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0617fa8",
  null
  
)

export default component.exports